module.exports = __webpack_public_path__ + "img/02_Shortlist_Notification.97bd315d.png";